import { render } from "./ButtonFormBuilder.vue?vue&type=template&id=1bbfab46&scoped=true"
import script from "./ButtonFormBuilder.vue?vue&type=script&lang=ts"
export * from "./ButtonFormBuilder.vue?vue&type=script&lang=ts"

import "./ButtonFormBuilder.vue?vue&type=style&index=0&id=1bbfab46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1bbfab46"

export default script